import { render, staticRenderFns } from "./satisdagilimi.vue?vue&type=template&id=1dc2fd60&scoped=true"
import script from "./satisdagilimi.vue?vue&type=script&lang=js"
export * from "./satisdagilimi.vue?vue&type=script&lang=js"
import style0 from "./satisdagilimi.vue?vue&type=style&index=0&id=1dc2fd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2fd60",
  null
  
)

export default component.exports